import client from './client';

// ── I1：仿真参数包（流体/能耗） ──
export interface SimulationParamView {
  key: string;
  name: string;
  unit: string;
  default?: number;
  warn?: number;
  critical?: number;
}

export interface SimulationPackView {
  key: string;
  name: string;
  category: 'fluid' | 'energy';
  description: string;
  params: SimulationParamView[];
}

export async function fetchSimulationPresets(): Promise<{ packs: SimulationPackView[] }> {
  const { data } = await client.get('/simulation/presets');
  return data;
}

export interface SimulationRuleDraftBody {
  packKey: string;
  paramKey: string;
  operator?: 'greaterThan' | 'greaterThanInclusive' | 'lessThan' | 'lessThanInclusive';
  value?: number;
  level?: 'warn' | 'error';
}

export interface SimulationRuleDraft {
  name: string;
  description: string;
  enabled: boolean;
  priority: number;
  eventCodes: string[] | null;
  conditions: Record<string, unknown>;
  actions: Array<{ type: 'alert'; params: { level: string; message: string } }>;
  cooldownMs: number;
}

export async function fetchSimulationRuleDraft(body: SimulationRuleDraftBody): Promise<SimulationRuleDraft> {
  const { data } = await client.post('/simulation/rules-draft', body);
  return data;
}
